//# sourceURL=CMAFacade.js
/**
 * Created by Ilian Bratanov on 5/10/2018.
 */
var CMAFacade = /** @class */ (function () {
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function CMAFacade() {
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    /**
     * Pass to this method initData for init all monitorings
     *
     * @param initData
     */
    CMAFacade.prototype.initCMA = function (initData) {
        this.initData = initData;
        this.isRealityCheckFinished = false;
        this.POPUP_PARENT = this.initData.popupParent;
        this._popupManager = new HTMLPopupManager();
        this.messageMonitor = new MessageMonitoring(initData.translations, initData.clientToken, initData.playerTokenId, initData.homeURL);
        this.realityCheckMonitor = new RealityCheckMonitoring(initData.translations, initData.regulationType, initData.loadGameData, initData.clientToken, initData.playerTokenId, initData.homeURL, initData.historyUrl);
        this.errorMessageService = new ErrorMessageService();
        this.popupMessageService = new CustomPopupService();
        this.replayMessageService = new ReplayMessageService();
        this.notifyService = new NotifyService(this.initData.baseUrl + initData.notifyUrl, initData.clientToken, initData.playerTokenId);
        this.uiTimerService = new UiTimerService();
        this.uiTimer = initData.uiTimer;
    };
    /**
     * Pass to this method data received in the server response.
     * It will be parsed by monitors and if needed reality check
     *
     * @param data
     */
    CMAFacade.prototype.handleServerData = function (data, textMessage) {
        this.realityCheckMonitor.checkObject(data, textMessage);
        this.messageMonitor.checkObject(data, textMessage);
    };
    /**
     * Pass to this method data received in the server status response.
     * It will be parsed by monitors
     * error will be shown
     *
     * @param status
     * @param buttons
     */
    CMAFacade.prototype.handleErrorStatusData = function (status, buttons, notifyCallback, contex) {
        var errorData = {
            Title: status.TranslationTitle,
            Text: status.ErrMessage || status.TranslationText,
            ErrorCode: status.ErrCode,
            Buttons: []
        };
        if (buttons) {
            errorData.Buttons = buttons;
        }
        if (status.ErrType === ErrorTypeConsts.GENERAL_ERROR) {
            this.errorMessageService.initErrorMessage(errorData);
        }
        else if (status.ErrType === ErrorTypeConsts.TEMPORARY_ERROR && notifyCallback && contex) {
            if (notifyCallback && contex) {
                var errorDataNotify = {
                    Title: status.TranslationTitle,
                    Text: status.TranslationText,
                    ErrorCode: status.ErrCode,
                    Buttons: []
                };
                this.notifyService.start(notifyCallback, contex, errorDataNotify);
            }
            else {
                this.errorMessageService.initErrorMessage(errorData);
            }
            // this.errorMessageService.initErrorMessage(errorData);
        }
        else if (status.ErrType === ErrorTypeConsts.VAUCHER_MODE_ERROR) {
        }
    };
    CMAFacade.prototype.navigateToURL = function (url, forceNewTab) {
        if (forceNewTab === void 0) { forceNewTab = false; }
        if (forceNewTab) {
            window.open(url, '_blank');
        }
        else {
            window.open(url, '_self');
        }
        /* TODO
            window.location.href = url;
            window.top.location.href = url;
         */
    };
    CMAFacade.prototype.showReplayPopup = function (replayObject) {
        this.replayMessageService.initReplayMessage(replayObject);
    };
    CMAFacade.prototype.showGeneralErrorPopup = function (errorData) {
        this.errorMessageService.initErrorMessage(errorData);
    };
    CMAFacade.prototype.showPopup = function (popupData) {
        this.popupMessageService.initPopupMessage(popupData);
    };
    Object.defineProperty(CMAFacade.prototype, "htmlPopupManager", {
        get: function () {
            return this._popupManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CMAFacade.prototype, "isDesktop", {
        get: function () {
            //TODO
            return true;
        },
        enumerable: true,
        configurable: true
    });
    CMAFacade.prototype.closePopup = function (popup) {
        popup.closePopup();
    };
    CMAFacade.prototype.closeAllPopups = function () {
        this._popupManager.closeAll();
    };
    CMAFacade.prototype.startUiTimer = function (updateUiTimer) {
        // Run UI Timer
        this.uiTimerService.start(updateUiTimer);
    };
    return CMAFacade;
}());
/**
 * Created by Ilian Bratanov on 10/8/2018.
 */
var AbstractCMAMonitor = /** @class */ (function () {
    // -----------------------------------------
    // PRIVATE PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function AbstractCMAMonitor(textData, clientToken, playerTokenId, homeURL) {
        this.textData = textData;
        this.clientToken = clientToken;
        this.playerTokenId = playerTokenId;
        this.homeURL = homeURL;
    }
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    AbstractCMAMonitor.prototype.changeButtonTextByAction = function (buttons) {
        var _this = this;
        buttons.forEach(function (button) {
            if (!button.Text) {
                switch (button.Action) {
                    case CMAButtonTypeConsts.Continue: {
                        button.Text = _this.textData.button1;
                        break;
                    }
                    case CMAButtonTypeConsts.Cashier: {
                        button.Text = _this.textData.button2;
                        break;
                    }
                    case CMAButtonTypeConsts.History: {
                        button.Text = _this.textData.buttonHistory;
                        break;
                    }
                    case CMAButtonTypeConsts.Link: {
                        button.Text = _this.textData.buttonDeposit;
                        break;
                    }
                    case CMAButtonTypeConsts.Quit: {
                        button.Text = _this.textData.button3;
                        break;
                    }
                    default:
                        break;
                }
            }
        });
        return buttons;
    };
    return AbstractCMAMonitor;
}());
//# sourceURL=game/AbstractCMAService.js
/**
 * Created by Ilian Bratanov on 6/11/2018.
 */
var AbstractCMAService = /** @class */ (function () {
    // -----------------------------------------
    // STATIC PROPERTIES/METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PUBLIC PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PROTECTED PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function AbstractCMAService() {
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    AbstractCMAService.prototype.onButtonClickCallback = function (button) { };
    return AbstractCMAService;
}());
//# sourceURL=game/AbstractHTMLPopup.js
/**
 * Created by Ilian Bratanov on 3/23/2018.
 */
//declare var server: any;
var AbstractHTMLPopup = /** @class */ (function () {
    // -----------------------------------------
    // PRIVATE PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function AbstractHTMLPopup(data) {
        this.POPUP_PARENT = CMA.POPUP_PARENT; //"#game_container";
        /** Additional scale factor for portrait mode - may be overridden (set 0 to disable resize) */
        this.PORTRAIT_SCALE_FACTOR = 0;
        this.data = data;
        this.onPopupClose = new Signal();
        this.onPopupOpen = new Signal();
        this.onClickButton = new Signal();
        this.onPopupHide = new Signal();
        this.onPopupShow = new Signal();
        this.isHTMLText = false;
        this.isOpenPopup = false;
        if (data.displayType === DisplayType.PopupModal) {
            this.isModal = true;
            this.isNotification = false;
        }
        else if (data.displayType === DisplayType.Notification) {
            this.isNotification = true;
            this.isModal = false;
        }
        else if (data.displayType === DisplayType.PopupNonModal) {
            this.isModal = false;
            this.isNotification = false;
        }
        else {
            this.isModal = true;
            this.isNotification = false;
        }
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    AbstractHTMLPopup.prototype.openPopup = function () {
        this.createPopupDomElementsByData(this.data);
        this.isOpenPopup = true;
        this.onPopupOpen.dispatch(this);
        if (this.backgroundDiv) {
            // attach to background div, set relative position and remove top offset - content centered
            this.popupDiv.appendTo(this.backgroundDiv);
            this.popupDiv.css('position', 'relative');
            this.popupDiv.css('top', '0px');
        }
        // TODO: It's only for portreit mode
        // this.resizeEvent = (typeof (ResolutionManager) !== 'undefined') ? ResolutionManager.onOrientationChange :
        // null;
        if (this.resizeEvent)
            this.resizeEvent.add(this.onAppResize, this);
        this.onAppResize();
    };
    AbstractHTMLPopup.prototype.closePopup = function () {
        if (this.resizeEvent)
            this.resizeEvent.remove(this.onAppResize, this);
        this.clearPopupDomElements();
        this.isOpenPopup = false;
        this.isHTMLText = false;
        this.onPopupClose.dispatch(this);
    };
    AbstractHTMLPopup.prototype.hidePopup = function () {
        this.popupDiv.hide();
        if (this.backgroundDiv) {
            this.backgroundDiv.hide();
        }
        this.onPopupHide.dispatch(this);
    };
    AbstractHTMLPopup.prototype.showPopup = function () {
        this.popupDiv.show();
        if (this.backgroundDiv) {
            this.backgroundDiv.show();
        }
        this.onPopupShow.dispatch(this);
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    AbstractHTMLPopup.prototype.createPopupDomElementsByData = function (data) {
        this.createPopupStructure();
        this.titlePopupDiv.append(data.title);
        var messageParagraph = $("<p/>", {
            id: "messageParagraph",
            text: data.text
        }).appendTo(this.messagePopupDiv);
        if (data.text2) {
            messageParagraph.append("<br/>" + data.text2);
        }
        var that = this;
        if (data.buttons) {
            for (var index = 0; index < data.buttons.length; index++) {
                var buttonDomElement = $("<button/>", {
                    class: "messageButton",
                    text: data.buttons[index].Text
                }).appendTo(this.buttonsPopupDiv);
                buttonDomElement.click(function () {
                    var buttonIndex = $(this).index();
                    that.onClickButton.dispatch(data.buttons[buttonIndex]);
                });
            }
        }
        var message = data.text;
        var regHTML = new RegExp("<\/?!?(img|a|div|p|ul|li|strong|h1|h2|h3|h4|h5|h6|br|span|b|big)[^>]*>");
        var checkHTML = message.search(regHTML);
        if (checkHTML !== -1) {
            this.messagePopupDiv = this.messagePopupDiv.empty();
            this.messagePopupDiv.append(message);
            this.isHTMLText = true;
        }
    };
    AbstractHTMLPopup.prototype.clearPopupDomElements = function () {
        $(this.popupDiv).remove();
    };
    AbstractHTMLPopup.prototype.createDivBackground = function () {
        var backgroundPopup = $('<div/>', {
            id: 'backgroundPopup'
        }).appendTo(this.POPUP_PARENT);
        return backgroundPopup;
    };
    /** additional resize popup according to portrait or landscape orientation */
    AbstractHTMLPopup.prototype.onAppResize = function () {
        if (this.PORTRAIT_SCALE_FACTOR > 0) {
            var isPortrait = this.isPortraitOrientation();
            this.setScaleTo(this.popupDiv, isPortrait ? this.PORTRAIT_SCALE_FACTOR : 1);
        }
    };
    /** check for portrait orientation */
    AbstractHTMLPopup.prototype.isPortraitOrientation = function () {
        var parentDiv = this.popupDiv ? this.popupDiv.parent() : null;
        if (parentDiv) {
            var parentWidth = parentDiv.width();
            var parentHeight = parentDiv.height();
            if (parentWidth < parentHeight) {
                return true;
            }
        }
        return false;
    };
    /** scale div */
    AbstractHTMLPopup.prototype.setScaleTo = function (div, scale) {
        if (div) {
            var strScale = "scale(" + scale + "," + scale + ")";
            div.css("transform", strScale);
        }
    };
    /** how many buttons in the popup? */
    AbstractHTMLPopup.prototype.getAmountButtons = function () {
        return ((this.data.buttons ? this.data.buttons.length : 0) || 0);
    };
    /** restyle generic popup buttons to have sufficient space */
    AbstractHTMLPopup.prototype.restyleGenericPopupButtons = function (div, amountButtons) {
        if (div) {
            var btns = div.children(".messageButton");
            if (btns) {
                // combine classes to override style
                btns.addClass(amountButtons < 3 ? "buttonWide" : "buttonNarrow");
            }
        }
    };
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    AbstractHTMLPopup.prototype.createPopupStructure = function () {
        this.popupDiv = $('<div/>', {
            id: "popupDiv"
        }).appendTo(this.POPUP_PARENT);
        this.titlePopupDiv = $('<div/>', {
            id: "titlePopupDiv"
        }).appendTo(this.popupDiv);
        this.messagePopupDiv = $("<div/>", {
            id: 'messagePopupDiv',
        }).appendTo(this.popupDiv);
        this.buttonsPopupDiv = $("<div/>", {
            id: "buttonsPopupDiv"
        }).appendTo(this.popupDiv);
    };
    return AbstractHTMLPopup;
}());
/**
 * Created by Ilian Bratanov on 5/8/2018.
 */
var CMAButtonTypeConsts;
(function (CMAButtonTypeConsts) {
    CMAButtonTypeConsts["Continue"] = "continue";
    CMAButtonTypeConsts["Quit"] = "quit";
    CMAButtonTypeConsts["Cashier"] = "cashier";
    CMAButtonTypeConsts["History"] = "history";
    CMAButtonTypeConsts["Link"] = "link";
})(CMAButtonTypeConsts || (CMAButtonTypeConsts = {}));
var ButtonLinkType;
(function (ButtonLinkType) {
    ButtonLinkType[ButtonLinkType["Redirect"] = 1] = "Redirect";
    ButtonLinkType[ButtonLinkType["Ajax"] = 2] = "Ajax";
    ButtonLinkType[ButtonLinkType["AjaxResponse"] = 3] = "AjaxResponse";
})(ButtonLinkType || (ButtonLinkType = {}));
var DisplayType;
(function (DisplayType) {
    DisplayType[DisplayType["Notification"] = 1] = "Notification";
    DisplayType[DisplayType["PopupModal"] = 2] = "PopupModal";
    DisplayType[DisplayType["PopupNonModal"] = 3] = "PopupNonModal";
})(DisplayType || (DisplayType = {}));
var PopupType;
(function (PopupType) {
    PopupType["MessagePopup"] = "MessagePopup";
    PopupType["RealityCheckPopup"] = "RealityCheckPopup";
    PopupType["ErrorPopup"] = "ErrorPopup";
    PopupType["NotificationPopup"] = "NotificationPopup";
    PopupType["ReplyPopup"] = "ReplayPopup";
    PopupType["CustomPopup"] = "CustomPopup";
})(PopupType || (PopupType = {}));
var ErrorCodesConsts;
(function (ErrorCodesConsts) {
    // This is sent when user does not have fund to pay for the bet or when his ecomenrece tickets have reached 0
    ErrorCodesConsts[ErrorCodesConsts["HAVE_NO_FUNDS"] = 112] = "HAVE_NO_FUNDS";
})(ErrorCodesConsts || (ErrorCodesConsts = {}));
var RegulationType;
(function (RegulationType) {
    RegulationType[RegulationType["ENGLAND"] = 2] = "ENGLAND";
    RegulationType[RegulationType["ITALY"] = 3] = "ITALY";
    RegulationType[RegulationType["SPAIN"] = 4] = "SPAIN";
    RegulationType[RegulationType["DENMARK"] = 5] = "DENMARK";
    RegulationType[RegulationType["SWEDEN"] = 6] = "SWEDEN";
    RegulationType[RegulationType["USA"] = 7] = "USA";
})(RegulationType || (RegulationType = {}));
/**
 *  This is valid list of unique game error codes only for RGS to RGS, if you need this to work for Legacy
 *  my prayers goes with you !
 */
var UniqueErrorCodesConsts;
(function (UniqueErrorCodesConsts) {
    // SERVER CODES
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["UnexpectedError"] = 1] = "UnexpectedError";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["SessionExpired"] = 2] = "SessionExpired";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["BetWasNotPlaced"] = 3] = "BetWasNotPlaced";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["InsufficientFunds"] = 4] = "InsufficientFunds";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["GameIsUnavailable"] = 5] = "GameIsUnavailable";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["ModelValidationError"] = 6] = "ModelValidationError";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["NoRoundsLeft"] = 7] = "NoRoundsLeft";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["TransactionsAreCurrentlyLockedForThisRound"] = 8] = "TransactionsAreCurrentlyLockedForThisRound";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["TemporaryError"] = 9] = "TemporaryError";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["LossLimitReached"] = 10] = "LossLimitReached";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["VoucherEndedOrCommitted"] = 11] = "VoucherEndedOrCommitted";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["PlayerAccountIsLocked"] = 12] = "PlayerAccountIsLocked";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["InvalidStake"] = 13] = "InvalidStake";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["IpRestricted"] = 14] = "IpRestricted";
    // CLIENT CODES
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["FILE_LOADING_FAILED"] = 401] = "FILE_LOADING_FAILED";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["HTTP_REQUEST_FAILED"] = 402] = "HTTP_REQUEST_FAILED";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["RELOAD_AGAIN"] = 403] = "RELOAD_AGAIN";
    UniqueErrorCodesConsts[UniqueErrorCodesConsts["UNKNOWN"] = 413] = "UNKNOWN"; // used for any client generated errors which are not clear to
    // which of the existing
})(UniqueErrorCodesConsts || (UniqueErrorCodesConsts = {}));
/**
 * This are groups of errors in which errors fall by.
 * 99% of the errors fall into GENERAL_ERROR category.
 */
var ErrorTypeConsts;
(function (ErrorTypeConsts) {
    ErrorTypeConsts[ErrorTypeConsts["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorTypeConsts[ErrorTypeConsts["GENERAL_ERROR"] = 1] = "GENERAL_ERROR";
    ErrorTypeConsts[ErrorTypeConsts["TEMPORARY_ERROR"] = 2] = "TEMPORARY_ERROR";
    ErrorTypeConsts[ErrorTypeConsts["VAUCHER_MODE_ERROR"] = 3] = "VAUCHER_MODE_ERROR"; // not sure when and how is used ?!
})(ErrorTypeConsts || (ErrorTypeConsts = {}));
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="./../abstractClasses/AbstractHTMLPopup.ts" />
//# sourceURL=game/ErrorMessageHTMLPopup.js
/**
 * Created by Ilian Bratanov on 4/13/2018.
 */
var ErrorMessageHTMLPopup = /** @class */ (function (_super) {
    __extends(ErrorMessageHTMLPopup, _super);
    // -----------------------------------------
    // STATIC PROPERTIES/METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PUBLIC PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PROTECTED PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function ErrorMessageHTMLPopup(data) {
        var _this = _super.call(this, data) || this;
        // -----------------------------------------
        // CONFIGURATION
        // -----------------------------------------
        /** Additional scale factor for portrait mode - may be overridden (set 0 to disable resize) */
        _this.PORTRAIT_SCALE_FACTOR = 1.75;
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    ErrorMessageHTMLPopup.prototype.openPopup = function () {
        if (!this.backgroundDiv) {
            this.backgroundDiv = this.createDivBackground();
        }
        _super.prototype.openPopup.call(this);
        this.restyleGenericPopupButtons(this.buttonsPopupDiv, this.getAmountButtons());
    };
    ErrorMessageHTMLPopup.prototype.closePopup = function () {
        _super.prototype.closePopup.call(this);
        if (this.backgroundDiv) {
            this.backgroundDiv.remove();
        }
    };
    return ErrorMessageHTMLPopup;
}(AbstractHTMLPopup));
//# sourceURL=game/ErrorMessageService.js
/**
 * Created by Ilian Bratanov on 5/9/2018.
 */
var ErrorMessageService = /** @class */ (function (_super) {
    __extends(ErrorMessageService, _super);
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function ErrorMessageService() {
        var _this = _super.call(this) || this;
        _this.popups = [];
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    ErrorMessageService.prototype.initErrorMessage = function (errorMessageObjectModelType) {
        if (this.popup && this.popup.isOpenPopup) {
            this.popup.closePopup();
        }
        this.popup = this.createHTMLPopup(errorMessageObjectModelType);
        if (errorMessageObjectModelType.ErrorCode === 555) {
            this.onButtonClickCallback(errorMessageObjectModelType.Buttons[0]);
            return;
        }
        this.popups.push(this.popup);
        this.popup.openPopup();
        this.popup.onClickButton.add(this.onButtonClickCallback, this);
    };
    ErrorMessageService.prototype.closeAllErrorPopup = function () {
        this.popups.forEach(function (popup) {
            popup.closePopup();
        });
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    ErrorMessageService.prototype.onButtonClickCallback = function (button) {
        if (button.CallBack) {
            button.CallBack.call(button.Contex);
        }
        switch (button.Action) {
            case CMAButtonTypeConsts.Continue: {
                this.popup.closePopup();
                break;
            }
            case CMAButtonTypeConsts.Link: {
                CMA.navigateToURL(button.Link);
                break;
            }
            default:
                break;
        }
        this.closeAllErrorPopup();
    };
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    ErrorMessageService.prototype.createHTMLPopup = function (errorObject) {
        var htmlData = {
            title: errorObject.Title,
            text: errorObject.Text,
            buttons: errorObject.Buttons
        };
        var htmlPopup = CMA.htmlPopupManager.createPopupByType(htmlData, PopupType.ErrorPopup);
        return htmlPopup;
    };
    return ErrorMessageService;
}(AbstractCMAService));
/// <reference path="./../abstractClasses/AbstractHTMLPopup.ts" />
//# sourceURL=game/MessageHTMLPopup.js
/**
 * Created by Ilian Bratanov on 5/8/2018.
 */
var MessageHTMLPopup = /** @class */ (function (_super) {
    __extends(MessageHTMLPopup, _super);
    // -----------------------------------------
    // STATIC PROPERTIES/METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PUBLIC PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PROTECTED PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function MessageHTMLPopup(data) {
        var _this = _super.call(this, data) || this;
        // -----------------------------------------
        // CONFIGURATION
        // -----------------------------------------
        /** Additional scale factor for portrait mode - may be overridden (set 0 to disable resize) */
        _this.PORTRAIT_SCALE_FACTOR = 1.75;
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    MessageHTMLPopup.prototype.openPopup = function () {
        if (this.isModal) {
            this.backgroundDiv = this.createDivBackground();
        }
        _super.prototype.openPopup.call(this);
        this.restyleGenericPopupButtons(this.buttonsPopupDiv, this.getAmountButtons());
    };
    MessageHTMLPopup.prototype.closePopup = function () {
        _super.prototype.closePopup.call(this);
        if (this.backgroundDiv) {
            this.backgroundDiv.remove();
        }
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    MessageHTMLPopup.prototype.createPopupDomElementsByData = function (data) {
        _super.prototype.createPopupDomElementsByData.call(this, data);
    };
    return MessageHTMLPopup;
}(AbstractHTMLPopup));
/// <reference path="../abstractClasses/AbstractCMAMonitor.ts" />
//# sourceURL=game/MessageMonitoring.js
var MessageMonitoring = /** @class */ (function (_super) {
    __extends(MessageMonitoring, _super);
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function MessageMonitoring(textData, clientToken, playerTokenId, homeURL) {
        var _this = _super.call(this, textData, clientToken, playerTokenId, homeURL) || this;
        _this.messageService = new MessageService(clientToken, playerTokenId, homeURL);
        _this.messagesObjectModelType = [];
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    MessageMonitoring.prototype.checkObject = function (resultCalbackObject, textData) {
        if (textData) {
            this.textData = textData;
        }
        if (this.messagesObjectModelType.length) {
            this.messagesObjectModelType = [];
        }
        if (resultCalbackObject && resultCalbackObject.Message) {
            if (resultCalbackObject.Message.length == 0) {
                return;
            }
            for (var index = 0; index < resultCalbackObject.Message.length; index++) {
                var messageObject = this.createMessageObjectByResponse(resultCalbackObject.Message[index]);
                this.messagesObjectModelType.push(messageObject);
            }
            console.log("Monitoring messageobject", this.messagesObjectModelType);
            this.messageService.initPopups(this.messagesObjectModelType);
        }
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    MessageMonitoring.prototype.createMessageObjectByResponse = function (response) {
        var objectMessageDefalt = {
            DisplayType: null,
            Title: "",
            Text: "",
            Buttons: [{
                    Text: "",
                    Action: ""
                }
            ]
        };
        if (response.DisplayType || response.DisplayType === 1) {
            objectMessageDefalt.DisplayType = response.DisplayType;
        }
        if (response.Title) {
            objectMessageDefalt.Title = response.Title;
        }
        if (response.Text) {
            objectMessageDefalt.Text = response.Text;
        }
        if (response.Buttons) {
            objectMessageDefalt.Buttons = response.Buttons;
            objectMessageDefalt.Buttons = this.changeButtonTextByAction(objectMessageDefalt.Buttons);
        }
        return objectMessageDefalt;
    };
    return MessageMonitoring;
}(AbstractCMAMonitor));
/// <reference path="../abstractClasses/AbstractCMAService.ts" />
//# sourceURL=/pp_framework/dev/Infrastructure/flow/MessageServicece.js
/**
 * Created by Ilian Bratanov on 4/5/2018.
 */
var MessageService = /** @class */ (function (_super) {
    __extends(MessageService, _super);
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function MessageService(clientToken, playerTokenId, homeURL) {
        var _this = _super.call(this) || this;
        // -----------------------------------------
        // STATIC PROPERTIES/METHODS
        // -----------------------------------------
        // -----------------------------------------
        // PUBLIC PROPERTIES
        // -----------------------------------------
        _this.NOTIFICATION_MESSAGE_DELAY = 7000;
        _this.clientToken = clientToken;
        _this.playerTokenId = playerTokenId;
        _this.homeURL = homeURL;
        _this.isFinishPopups = true;
        _this.popups = [];
        _this.eventsNotificationService = new PostDataService(_this.homeURL);
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    MessageService.prototype.initPopups = function (messagesObject) {
        this.messagesObject = messagesObject;
        for (var index = 0; index < this.messagesObject.length; index++) {
            var htmlPopup = this.createHTMLPopup(this.messagesObject[index]);
            htmlPopup.onClickButton.add(this.onButtonClickCallback, this);
            this.popups.push(htmlPopup);
        }
        this.sortMessagesPopupsFirstModal(this.popups);
        CMA.htmlPopupManager.onCloseAllPopups.add(this.closeAllPopups, this);
        this.start();
    };
    MessageService.prototype.start = function () {
        var _this = this;
        if (this.popup && this.popup.isOpenPopup && !this.popup.isNotification) {
            return;
        }
        else if (this.popup && this.popup.isNotification && this.popup.isOpenPopup) {
            this.popup.closePopup();
            if (this.notificationTimer) {
                //game.time.events.remove(this.notificationTimer);
                clearTimeout(this.notificationTimer);
            }
            // return;
        }
        this.popup = this.popups.shift();
        this.popup.openPopup();
        // this.popup.onPopupClose.add(this.onClosePopupHandler, this);
        if (this.popup.isNotification) {
            this.notificationTimer = setTimeout(function () {
                _this.closeNotificationMessage(_this.popup);
            }, this.NOTIFICATION_MESSAGE_DELAY);
            //game.time.events.add(this.NOTIFICATION_MESSAGE_DELAY, this.closeNotificationMessage, this,
            // this.popup);
        }
    };
    MessageService.prototype.end = function () {
        this.isFinishPopups = true;
        CMA.htmlPopupManager.closeAll();
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    MessageService.prototype.onButtonClickCallback = function (button) {
        this.popup.onClickButton.dispose();
        if (!button) {
            this.closeNotificationMessage(this.popup);
            return;
        }
        switch (button.Action) {
            case CMAButtonTypeConsts.Continue:
                {
                    if (button.Link) {
                        this.postByLinkTypeButton(button);
                    }
                    this.popup.closePopup();
                    break;
                }
            case CMAButtonTypeConsts.Cashier:
                {
                    CMA.navigateToURL(button.Link);
                    break;
                }
            case CMAButtonTypeConsts.History:
                {
                    CMA.navigateToURL(button.Link);
                    break;
                }
            case CMAButtonTypeConsts.Link:
                {
                    this.postByLinkTypeButton(button);
                    break;
                }
            case CMAButtonTypeConsts.Quit:
                {
                    CMA.navigateToURL(this.homeURL);
                    break;
                }
            default:
                break;
        }
        if (this.popup.isOpenPopup) {
            this.popup.closePopup();
        }
        if (this.popups.length) {
            this.start();
        }
    };
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    MessageService.prototype.sortMessagesPopupsFirstModal = function (popups) {
        var newArr = [];
        for (var index = 0; index < popups.length; index++) {
            var element = popups[index];
            if (element.isModal) {
                popups.splice(index, 1);
                index--;
                newArr.push(element);
            }
        }
        for (var index = newArr.length - 1; index >= 0; index--) {
            var element = newArr[index];
            popups.unshift(element);
        }
    };
    MessageService.prototype.createHTMLPopup = function (messageObject) {
        var htmlData = {
            title: messageObject.Title,
            text: messageObject.Text,
            buttons: messageObject.Buttons,
            displayType: messageObject.DisplayType
        };
        var htmlPopup = null;
        messageObject.Buttons.forEach(function (button) {
            if (button.LinkType) {
                button.Action = CMAButtonTypeConsts.Link;
            }
        });
        if (messageObject.DisplayType === DisplayType.Notification) {
            htmlPopup = CMA.htmlPopupManager.createPopupByType(htmlData, PopupType.NotificationPopup);
        }
        else {
            htmlPopup = CMA.htmlPopupManager.createPopupByType(htmlData, PopupType.MessagePopup);
        }
        return htmlPopup;
    };
    MessageService.prototype.closeAllPopups = function () {
        console.log("CloseAllPopups", this.popups.length);
        this.end();
    };
    MessageService.prototype.closeNotificationMessage = function (popup) {
        if (this.notificationTimer) {
            //game.time.events.remove(this.notificationTimer);
            clearTimeout(this.notificationTimer);
            this.notificationTimer = undefined;
        }
        popup.closePopup();
        if (this.popups.length) {
            this.start();
        }
        console.log("Close Notification popup");
    };
    MessageService.prototype.postByLinkTypeButton = function (button) {
        switch (button.LinkType) {
            case ButtonLinkType.Redirect:
                {
                    CMA.navigateToURL(button.Link, true);
                    break;
                }
            case ButtonLinkType.Ajax:
                {
                    this.eventsNotificationService.sendNotification(button.Link, this.clientToken, this.playerTokenId);
                    break;
                }
            case ButtonLinkType.AjaxResponse:
                {
                    var response = this.eventsNotificationService.sendNotification(button.Link, this.clientToken, this.playerTokenId);
                    break;
                }
            default:
                break;
        }
    };
    return MessageService;
}(AbstractCMAService));
//# sourceURL=game/PostDataService*
/**
 *
 */
var PostDataService = /** @class */ (function () {
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function PostDataService(eventUrl) {
        this.eventUrl = eventUrl;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    PostDataService.prototype.sendNotification = function (eventUrl, clientToken, playerTokenId, eventNotification) {
        var data = {
            ClientToken: clientToken,
            PlayerTokenId: playerTokenId,
            EventNotificaiton: eventNotification
        };
        $.post(eventUrl, data, function (result) {
            console.log("Result -> ", result);
            return result;
        });
    };
    PostDataService.prototype.post = function (data, url) {
        var postRequaste = $.post(url, data);
        postRequaste.then(function (result) {
            console.log("POST DONE => ", result);
            return result;
        });
        postRequaste.fail(function (errorChe) {
            console.error("ERROR POST", errorChe);
        });
        return postRequaste;
    };
    return PostDataService;
}());
//# sourceURL=game/NotificationHTMLPopup.js
/**
 * Created by Ilian Bratanov on 4/18/2018.
 */
var NotificationHTMLPopup = /** @class */ (function (_super) {
    __extends(NotificationHTMLPopup, _super);
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function NotificationHTMLPopup(data) {
        var _this = _super.call(this, data) || this;
        _this.LINES_BY_TEXT_AFTER_SHOWMORE = 2;
        _this.onResetTimer = new Signal();
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    NotificationHTMLPopup.prototype.openPopup = function () {
        _super.prototype.openPopup.call(this);
        this.titlePopupDiv.remove();
        var startPos = -(this.popupDiv.height());
        var heightPixels = this.popupDiv.height();
        this.animationNotification(startPos, heightPixels);
        this.restyleGenericPopupButtons(this.buttonsPopupDiv, this.getAmountButtons());
    };
    NotificationHTMLPopup.prototype.closePopup = function () {
        var _this = this;
        var startPos = this.popupDiv.position().top;
        var heightPixels = -(this.popupDiv.height());
        this.animationNotification(startPos, heightPixels);
        // This is callback when transition end
        this.popupDiv.one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
            _super.prototype.closePopup.call(_this);
        });
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    NotificationHTMLPopup.prototype.createPopupDomElementsByData = function (data) {
        var _this = this;
        _super.prototype.createPopupDomElementsByData.call(this, data);
        this.popupDiv.attr("id", "notificationDiv");
        var notificationParagraph = this.messagePopupDiv.children();
        notificationParagraph.remove();
        this.messagePopupDiv.attr("id", "messageNotificationDiv");
        this.buttonsPopupDiv.attr("id", "buttonsNotificationDiv");
        this.closeXButton = $('<img/>', {
            class: "notification-x-button",
        }).appendTo(this.popupDiv);
        this.closeXButton.click(function () {
            _this.onClickButton.dispatch();
        });
        this.messagePopupDiv.appendTo(this.popupDiv);
        this.buttonsPopupDiv.appendTo(this.popupDiv);
        var dataTitleText = data.title;
        var dataContextText = data.text;
        if (data.text2) {
            dataContextText += data.text2;
        }
        var notificationTitle = $("<span/>", {
            id: "notificationTitle"
        }).appendTo(this.messagePopupDiv);
        notificationParagraph = $("<span/>", {
            id: "notificationParagraph"
        }).appendTo(this.messagePopupDiv);
        var seeAllButton = $("<img/>", {
            id: "see-all",
        });
        var titlePaddingRight = (document.body.offsetWidth / 100); // 1% padding
        var fontFamily = this.messagePopupDiv.css("font-family");
        var fontSize = this.messagePopupDiv.css("font-size");
        var fontWeight = notificationTitle.css("font-weight");
        var usedAndNotUsedBodyText = this.getUsedAndNotUsedTextForNotification(dataTitleText, dataContextText, this.messagePopupDiv, this.LINES_BY_TEXT_AFTER_SHOWMORE, fontFamily, fontSize, fontWeight, titlePaddingRight);
        if (usedAndNotUsedBodyText.notUsed.length > 0) {
            seeAllButton.appendTo(this.messagePopupDiv);
            notificationTitle.append(dataTitleText);
            notificationParagraph.append(usedAndNotUsedBodyText.used);
        }
        else {
            notificationTitle.append(dataTitleText);
            notificationParagraph.append(dataContextText);
        }
        var that = this;
        seeAllButton.click(function () {
            notificationParagraph.append(usedAndNotUsedBodyText.notUsed);
            var lines = notificationParagraph.height() / usedAndNotUsedBodyText.lineHeight;
            lines = Math.floor(lines);
            var notificationTimerDelay = that.resetNotificationTimerByTextLines(lines);
            that.onResetTimer.dispatch(notificationTimerDelay);
            seeAllButton.css("visibility", "hidden");
        });
    };
    NotificationHTMLPopup.prototype.onAppResize = function () {
        if (this.PORTRAIT_SCALE_FACTOR > 0) {
            var isPortrait = this.isPortraitOrientation();
            this.setScaleTo(this.popupDiv, isPortrait ? this.PORTRAIT_SCALE_FACTOR : 1);
        }
    };
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    NotificationHTMLPopup.prototype.getUsedAndNotUsedTextForNotification = function (title, body, domElement, lines, fontFamily, fontSize, fontWeight, paddingRight) {
        var result = {
            used: '',
            notUsed: '',
            lineHeight: 0
        };
        var titleSpan = document.createElement('span');
        var bodySpan = document.createElement('span');
        var allDiv = document.createElement('div');
        var bodyWords = body.split(" ");
        allDiv.appendChild(titleSpan);
        allDiv.appendChild(bodySpan);
        domElement.append(allDiv);
        titleSpan.style.fontSize = fontSize;
        titleSpan.style.fontFamily = fontFamily;
        if (fontWeight) {
            titleSpan.style.fontWeight = fontWeight;
        }
        if (paddingRight) {
            titleSpan.style.paddingRight = paddingRight + "px";
        }
        bodySpan.style.fontSize = fontSize;
        bodySpan.style.fontFamily = fontFamily;
        titleSpan.innerText = "";
        var LINE_HEIGHT = titleSpan.offsetHeight + 1;
        result.lineHeight = LINE_HEIGHT - 1;
        titleSpan.innerText = title;
        var bodyWord = "";
        for (var index = 0; index < bodyWords.length; index++) {
            bodyWord += bodyWords[index];
            bodyWord += " ";
            bodySpan.innerText = bodyWord;
            if (allDiv.offsetHeight <= LINE_HEIGHT * lines) {
                result.used += bodyWords[index];
                result.used += " ";
            }
            else {
                result.notUsed += bodyWords[index];
                result.notUsed += " ";
            }
        }
        bodySpan.parentNode.removeChild(bodySpan);
        titleSpan.parentNode.removeChild(titleSpan);
        allDiv.parentNode.removeChild(allDiv);
        return result;
    };
    NotificationHTMLPopup.prototype.resetNotificationTimerByTextLines = function (lines) {
        var notificationTimerDelayByLine = 0;
        var sevenSeconds = 7;
        var twoSecond = 2;
        notificationTimerDelayByLine += (lines * twoSecond);
        notificationTimerDelayByLine = Math.max(notificationTimerDelayByLine, sevenSeconds);
        notificationTimerDelayByLine *= 1000;
        return notificationTimerDelayByLine;
    };
    NotificationHTMLPopup.prototype.animationNotification = function (startPositinY, heightPixels) {
        this.popupDiv.attr("style", "top:" + startPositinY + "px");
        this.popupDiv.css("transform", "translateY(" + heightPixels + "px)");
    };
    // -----------------------------------------
    // STATIC PROPERTIES/METHODS
    // -----------------------------------------
    NotificationHTMLPopup.CLOSE_BUTTON_IMAGE_SRC = "close_button.png";
    NotificationHTMLPopup.READ_MORE_BUTTON_IMAGE_SRC = "see_more_button.png";
    return NotificationHTMLPopup;
}(AbstractHTMLPopup));
/// <reference path="./../abstractClasses/AbstractCMAService.ts" />
//# sourceURL=/pp_framework/dev/Infrastructure/flow/NotifyService.js
/**
 * Created by Ilian Bratanov on 19/10/2018.
 */
var NotifyService = /** @class */ (function (_super) {
    __extends(NotifyService, _super);
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function NotifyService(url, clientToken, playerTokenId) {
        var _this = _super.call(this) || this;
        // -----------------------------------------
        // STATIC PROPERTIES/METHODS
        // -----------------------------------------
        // -----------------------------------------
        // PUBLIC PROPERTIES
        // -----------------------------------------
        _this.DELAY_BETWEEN_CALLS = 5000;
        _this.url = url;
        _this.clientToken = clientToken;
        _this.playerTokenId = playerTokenId;
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    NotifyService.prototype.start = function (callback, contex, error) {
        var that = this;
        var data = {
            "ClientToken": this.clientToken,
            "PlayerTokenId": this.playerTokenId,
        };
        var Http = new XMLHttpRequest();
        Http.open("POST", this.url, true);
        Http.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        Http.onreadystatechange = function () {
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                // Request finished. Do processing here.
                var responseObject = JSON.parse(this.response);
                var newStatus = {
                    Text: error.Text,
                    ErrorCode: responseObject.Status.ErrCode,
                    Title: error.Title
                };
                if (responseObject === null || responseObject === '' || typeof responseObject.Status === 'undefined' || responseObject.Status === null) {
                    that.tryAgain(callback, contex, error);
                }
                else {
                    // check error type
                    if (responseObject.Status.ErrType === ErrorTypeConsts.TEMPORARY_ERROR) {
                        if (responseObject.Status.ErrMessage) {
                            that.isRecievedMessage = true;
                            newStatus.Text = responseObject.Status.ErrMessage;
                        }
                        CMA.errorMessageService.initErrorMessage(newStatus);
                        that.tryAgain(callback, contex, error);
                    }
                    else if (responseObject.Status.ErrType === ErrorTypeConsts.GENERAL_ERROR) {
                        CMA.errorMessageService.initErrorMessage(newStatus);
                        that.end(callback, contex, responseObject);
                    }
                    else if (responseObject.Status.ErrType === ErrorTypeConsts.NO_ERROR) {
                        that.end(callback, contex, responseObject);
                        CMA.errorMessageService.closeAllErrorPopup();
                    }
                }
            }
            else {
                if (!that.isRecievedMessage) {
                    var newStatus_1 = {
                        Text: error.Text,
                        Title: error.Title,
                        ErrorCode: 2
                    };
                    CMA.errorMessageService.initErrorMessage(newStatus_1);
                }
                var newStatus = {
                    Text: error.Text,
                    Title: error.Title,
                    ErrorCode: 2
                };
                CMA.errorMessageService.initErrorMessage(newStatus);
            }
        };
        var dataQuery = this.serializeQuery(data);
        Http.send(dataQuery);
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    NotifyService.prototype.tryAgain = function (callback, contex, args) {
        // delay between calls
        // start again
        var that = this;
        setTimeout(function () {
            that.start(callback, contex, args);
        }, that.DELAY_BETWEEN_CALLS, that);
    };
    NotifyService.prototype.end = function (callback, contex, result) {
        if (callback !== null) {
            callback.apply(contex, [result]);
        }
        //    CMA.errorMessageService.closeAllErrorPopup();
        this.isRecievedMessage = false;
    };
    NotifyService.prototype.serializeQuery = function (obj) {
        var str = [];
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
        return str.join("&");
    };
    return NotifyService;
}(AbstractCMAService));
/// <reference path="./../abstractClasses/AbstractHTMLPopup.ts" />
//# sourceURL=game/CustomHTMLPopup.js
/**
 * Created by Ilian Bratanov on 2/11/2018.
 */
var CustomHTMLPopup = /** @class */ (function (_super) {
    __extends(CustomHTMLPopup, _super);
    // -----------------------------------------
    // CONFIGURATION
    // -----------------------------------------
    // -----------------------------------------
    // STATIC PROPERTIES/METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PUBLIC PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PROTECTED PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function CustomHTMLPopup(data) {
        return _super.call(this, data) || this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    CustomHTMLPopup.prototype.openPopup = function () {
        if (this.isModal) {
            this.backgroundDiv = this.createDivBackground();
        }
        _super.prototype.openPopup.call(this);
        this.restyleGenericPopupButtons(this.buttonsPopupDiv, this.getAmountButtons());
    };
    CustomHTMLPopup.prototype.closePopup = function () {
        _super.prototype.closePopup.call(this);
        if (this.backgroundDiv) {
            this.backgroundDiv.remove();
        }
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    CustomHTMLPopup.prototype.createPopupDomElementsByData = function (data) {
        _super.prototype.createPopupDomElementsByData.call(this, data);
    };
    return CustomHTMLPopup;
}(AbstractHTMLPopup));
//# sourceURL=game/CustomPopupService.js
/**
 * Created by Ilian Bratanov on 2/11/2018.
 */
var CustomPopupService = /** @class */ (function (_super) {
    __extends(CustomPopupService, _super);
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function CustomPopupService() {
        var _this = _super.call(this) || this;
        _this.popups = [];
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    CustomPopupService.prototype.initPopupMessage = function (popupMessageObjectModelType) {
        if (this.popup && this.popup.isOpenPopup) {
            this.popup.closePopup();
        }
        this.popup = this.createHTMLPopup(popupMessageObjectModelType);
        this.popups.push(this.popup);
        this.popup.openPopup();
        this.popup.onClickButton.add(this.onButtonClickCallback, this);
    };
    CustomPopupService.prototype.closeAllErrorPopup = function () {
        this.popups.forEach(function (popup) {
            popup.closePopup();
        });
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    CustomPopupService.prototype.createHTMLPopup = function (popupObject) {
        var htmlData = {
            title: popupObject.Title,
            text: popupObject.Text,
            buttons: popupObject.Buttons
        };
        var htmlPopup = CMA.htmlPopupManager.createPopupByType(htmlData, PopupType.CustomPopup);
        return htmlPopup;
    };
    CustomPopupService.prototype.onButtonClickCallback = function (button) {
        this.popup.onClickButton.dispose();
        switch (button.Action) {
            case CMAButtonTypeConsts.Continue:
                {
                    if (button.Link) {
                        CMA.navigateToURL(button.Link);
                    }
                    this.popup.closePopup();
                    break;
                }
            case CMAButtonTypeConsts.Cashier:
                {
                    CMA.navigateToURL(button.Link);
                    break;
                }
            case CMAButtonTypeConsts.History:
                {
                    CMA.navigateToURL(button.Link);
                    break;
                }
            case CMAButtonTypeConsts.Quit:
                {
                    CMA.navigateToURL(button.Link);
                    break;
                }
            default:
                break;
        }
        if (this.popup.isOpenPopup) {
            this.popup.closePopup();
        }
    };
    return CustomPopupService;
}(AbstractCMAService));
//# sourceURL=game/HTMLPopupManager.js
/**
 * Created by Ilian Bratanov on 3/26/2018.
 */
var HTMLPopupManager = /** @class */ (function () {
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function HTMLPopupManager() {
        this.onCloseAllPopups = new Signal();
        this.openPopups = [];
        this.closePopups = [];
        this.popups = [];
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    HTMLPopupManager.prototype.closeAll = function () {
        this.openPopups.forEach(function (popup) {
            popup.closePopup();
        });
        this.closePopups = [];
        this.popups = [];
        this.onCloseAllPopups.dispatch();
    };
    HTMLPopupManager.prototype.createPopupByType = function (data, type) {
        var popup = null;
        switch (type) {
            case PopupType.RealityCheckPopup:
                {
                    popup = new RealityCheckUKHTMLPopup(data);
                    break;
                }
            case PopupType.MessagePopup:
                {
                    popup = new MessageHTMLPopup(data);
                    break;
                }
            case PopupType.ErrorPopup:
                {
                    popup = new ErrorMessageHTMLPopup(data);
                    break;
                }
            case PopupType.NotificationPopup:
                {
                    popup = new NotificationHTMLPopup(data);
                    break;
                }
            case PopupType.ReplyPopup:
                {
                    popup = new ReplayHTMLPopup(data);
                    break;
                }
            case PopupType.CustomPopup:
                {
                    popup = new CustomHTMLPopup(data);
                    break;
                }
            default:
                break;
        }
        this.popups.push(popup);
        popup.onPopupOpen.add(this.onOpenHandler, this);
        popup.onPopupClose.add(this.onCloseHandler, this);
        popup.onPopupHide.add(this.onHideHandler, this);
        popup.onPopupShow.add(this.onShowHandler, this);
        return popup;
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    HTMLPopupManager.prototype.onOpenHandler = function (popup) {
        var isRealituCheck = popup instanceof RealityCheckUKHTMLPopup;
        var isError = popup instanceof ErrorMessageHTMLPopup;
        if (isRealituCheck || isError) {
            this.popups.forEach(function (element) {
                if (element.isOpenPopup && !(element instanceof RealityCheckUKHTMLPopup) && !(element instanceof ErrorMessageHTMLPopup)) {
                    element.hidePopup();
                }
            });
        }
        popup.onPopupOpen.dispose();
        this.openPopups.push(popup);
    };
    HTMLPopupManager.prototype.onCloseHandler = function (popup) {
        if (this.hidePopup) {
            this.hidePopup.showPopup();
            return;
        }
        this.popups.shift();
        this.openPopups.shift();
        // popup.onPopupClose.dispose();
        this.closePopups.push(popup);
    };
    HTMLPopupManager.prototype.onHideHandler = function (popup) {
        this.hidePopup = popup;
        popup.onPopupHide.dispose();
    };
    HTMLPopupManager.prototype.onShowHandler = function (popup) {
        popup.onPopupShow.dispose();
    };
    return HTMLPopupManager;
}());
/// <reference path="../message/MessageMonitoring.ts" />
//# sourceURL=game/RealityCheckMonitoring.js
/**
 * Created by Ilian Bratanov on 10/8/2018.
 */
var RealityCheckMonitoring = /** @class */ (function (_super) {
    __extends(RealityCheckMonitoring, _super);
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function RealityCheckMonitoring(textData, regulationType, loopRealityCheck, clientToken, playerTokenId, homeURL, historyURL) {
        var _this = _super.call(this, textData, clientToken, playerTokenId, homeURL) || this;
        _this.historyURL = historyURL;
        _this.regulationType = regulationType;
        _this.queryStringData = _this.getQueryString();
        // let loopRealityCheck:boolean = (loadGameData.RealityCheckTimeout || loadGameData.realityCheckTimeout) != undefined;
        _this.realityCheckService = new RealityCheckUKService(loopRealityCheck, clientToken, playerTokenId, homeURL);
        _this.realityCheckSwedenService = new RealityCheckSwedenService(loopRealityCheck, clientToken, homeURL, _this.queryStringData);
        _this.realityCheckModel = {};
        _this.realityCheckTimer = new RealityCheckTimer();
        _this.postDataService = new PostDataService();
        _this.passedTime = 0;
        _this.passedDelay = 0;
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    RealityCheckMonitoring.prototype.checkObject = function (resultCalbackObject, textData) {
        if (textData) {
            this.textData = textData;
        }
        switch (this.regulationType) {
            case RegulationType.ENGLAND: {
                this.englandRegulation(resultCalbackObject);
                break;
            }
            case RegulationType.SWEDEN: {
                this.swedenRegulation(resultCalbackObject);
                break;
            }
            default:
                break;
        }
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    RealityCheckMonitoring.prototype.englandRegulation = function (resultCalbackObject) {
        if (resultCalbackObject && resultCalbackObject.RealityCheck || resultCalbackObject.RealityCheckTimeout || resultCalbackObject.realityCheckTimeout) {
            if (resultCalbackObject.RealityCheck) {
                this.realityCheckModel = this.createRealityCheckObjectByResponse(resultCalbackObject.RealityCheck);
            }
            else if (resultCalbackObject.RealityCheckTimeout || resultCalbackObject.realityCheckTimeout) {
                this.realityCheckModel = this.createRealityCheckObjectByResponse(resultCalbackObject);
            }
            if (this.realityCheckModel.RealityCheckTimeoutPassed === this.realityCheckModel.RealityCheckTimeout) {
                this.realityCheckModel.ShowRealityCheck = true;
            }
            if (this.realityCheckModel.ShowRealityCheck) {
                this.realityCheckModel.RealityCheckTimeoutPassed = this.realityCheckModel.RealityCheckTimeout;
            }
            if (this.realityCheckModel.RealityCheckTimeoutInSeconds) {
                this.realityCheckModel.RealityCheckTimeoutPassed = this.realityCheckModel.RealityCheckTimeoutPassed * 1000;
                this.realityCheckModel.RealityCheckTimeout = this.realityCheckModel.RealityCheckTimeout * 1000;
            }
            else {
                this.realityCheckModel.RealityCheckTimeoutPassed = this.realityCheckModel.RealityCheckTimeoutPassed * 1000 * 60;
                this.realityCheckModel.RealityCheckTimeout = this.realityCheckModel.RealityCheckTimeout * 1000 * 60;
            }
            console.log("Monitoring CheckObject", this.realityCheckModel);
            this.realityCheckService.init(this.realityCheckModel);
        }
    };
    RealityCheckMonitoring.prototype.swedenRegulation = function (resultCalbackObject) {
        if (resultCalbackObject.RealityCheckTimeout) {
            var loggedTime = Number(this.queryStringData.loggedintime);
            if (!loggedTime) {
                loggedTime = 0;
            }
            var loggedTimeInMinutes = loggedTime / 60;
            this.realityCheckModel.RealityCheckTimeoutPassed = loggedTimeInMinutes;
            this.realityCheckModel.RealityCheckTimeout = resultCalbackObject.RealityCheckTimeout;
            this.realityCheckSwedenService.init(this.realityCheckModel);
        }
    };
    RealityCheckMonitoring.prototype.getQueryString = function () {
        var result = {};
        var queryString = location.search.slice(1);
        var re = /([^&=]+)=([^&]*)/g;
        var m;
        while (m = re.exec(queryString)) {
            result[decodeURIComponent(m[1]).toLowerCase()] = decodeURIComponent(m[2]);
        }
        return result;
    };
    ;
    RealityCheckMonitoring.prototype.createRealityCheckObjectByResponse = function (response) {
        var objectRealityCheck = {
            RealityCheckTimeout: 0,
            RealityCheckTimeoutPassed: 0,
            RealityCheckTimeoutInSeconds: false,
            ShowRealityCheck: false,
            RealityCheck_NotificationContinueUrl: "",
            RealityCheck_NotificationQuitUrl: "",
            RealityCheckAvailableTimePeriods: [],
            Message: {
                Title: this.textData.title,
                Text: this.textData.text,
                Text2: this.textData.text2,
                Buttons: [{
                        Text: this.textData.button1,
                        Action: CMAButtonTypeConsts.Continue
                    }, {
                        Text: this.textData.button3,
                        Action: CMAButtonTypeConsts.Quit
                    }]
            }
        };
        if (response.HistoryUrl) {
            objectRealityCheck.Message.Buttons.splice(1, 0, {
                Text: this.textData.button2,
                Action: CMAButtonTypeConsts.History,
                Link: response.HistoryUrl
            });
        }
        if (response.RealityCheckTimeout) {
            objectRealityCheck.RealityCheckTimeout = response.RealityCheckTimeout;
        }
        if (response.realityCheckTimeout) {
            objectRealityCheck.RealityCheckTimeout = response.realityCheckTimeout;
        }
        if (response.RealityCheckTimeoutPassed) {
            objectRealityCheck.RealityCheckTimeoutPassed = response.RealityCheckTimeoutPassed;
        }
        if (response.hasOwnProperty("RealityCheckTimeoutInSeconds")) {
            objectRealityCheck.RealityCheckTimeoutInSeconds = response.RealityCheckTimeoutInSeconds;
        }
        if (response.hasOwnProperty("ShowRealityCheck")) {
            objectRealityCheck.ShowRealityCheck = response.ShowRealityCheck;
        }
        if (response.RealityCheckAvailableTimePeriods) {
            this.createAvailableTimePeriod(response.RealityCheckAvailableTimePeriods, objectRealityCheck);
        }
        if (response.RealityCheck_NotificationContinueUrl) {
            objectRealityCheck.RealityCheck_NotificationContinueUrl = response.RealityCheck_NotificationContinueUrl;
        }
        if (response.RealityCheck_NotificationQuitUrl) {
            objectRealityCheck.RealityCheck_NotificationQuitUrl = response.RealityCheck_NotificationQuitUrl;
        }
        if (response.Message) {
            if (response.Message.Title) {
                objectRealityCheck.Message.Title = response.Message.Title;
            }
            if (response.Message.Text) {
                objectRealityCheck.Message.Text = response.Message.Text;
            }
            if (response.Message.Text2) {
                objectRealityCheck.Message.Text2 = response.Message.Text2;
            }
            if (response.Message.Buttons) {
                objectRealityCheck.Message.Buttons = response.Message.Buttons;
                objectRealityCheck.Message.Buttons = this.changeButtonTextByAction(objectRealityCheck.Message.Buttons);
            }
        }
        return objectRealityCheck;
    };
    RealityCheckMonitoring.prototype.createAvailableTimePeriod = function (periods, object) {
        periods.forEach(function (period) {
            object.RealityCheckAvailableTimePeriods.push(period);
        });
    };
    return RealityCheckMonitoring;
}(AbstractCMAMonitor));
//# sourceURL=game/RealityCheckTimer.js
var RealityCheckTimer = /** @class */ (function () {
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function RealityCheckTimer() {
        this.onTimerComplete = new Signal();
        this.onTimerStart = new Signal();
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    RealityCheckTimer.prototype.start = function (delay, action, context) {
        var _this = this;
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.onTimerStart.dispatch();
        this.timer = setTimeout(function () {
            action.call(context, [delay]);
            _this.onTimerComplete.dispatch();
        }, delay);
    };
    return RealityCheckTimer;
}());
/// <reference path="./../../abstractClasses/AbstractHTMLPopup.ts" />
//# sourceURL=game/RealityCheckSwedenHTMLPopup.js
/**
 * Created by Ilian Bratanov on 6/11/2018.
 */
var RealityCheckSwedenHTMLPopup = /** @class */ (function (_super) {
    __extends(RealityCheckSwedenHTMLPopup, _super);
    // -----------------------------------------
    // CONFIGURATION
    // -----------------------------------------
    // -----------------------------------------
    // STATIC PROPERTIES/METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PUBLIC PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PROTECTED PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function RealityCheckSwedenHTMLPopup(data) {
        return _super.call(this, data) || this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    RealityCheckSwedenHTMLPopup.prototype.openPopup = function () {
        if (this.isModal) {
            this.backgroundDiv = this.createDivBackground();
        }
        _super.prototype.openPopup.call(this);
        this.restyleGenericPopupButtons(this.buttonsPopupDiv, this.getAmountButtons());
    };
    RealityCheckSwedenHTMLPopup.prototype.closePopup = function () {
        _super.prototype.closePopup.call(this);
        if (this.backgroundDiv) {
            this.backgroundDiv.remove();
        }
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    RealityCheckSwedenHTMLPopup.prototype.createPopupDomElementsByData = function (data) {
        _super.prototype.createPopupDomElementsByData.call(this, data);
    };
    return RealityCheckSwedenHTMLPopup;
}(AbstractHTMLPopup));
/// <reference path="./../../abstractClasses/AbstractCMAService.ts" />
//# sourceURL=game/RealityCheckService.js
var RealityCheckSwedenService = /** @class */ (function (_super) {
    __extends(RealityCheckSwedenService, _super);
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function RealityCheckSwedenService(loopRealityCheckTimer, clientToken, homeURL, queryStringData) {
        var _this = _super.call(this) || this;
        // -----------------------------------------
        // STATIC PROPERTIES/METHODS
        // -----------------------------------------
        // -----------------------------------------
        // PUBLIC PROPERTIES
        // -----------------------------------------
        _this.onTimerComplete = new Signal();
        _this.loopRealityCheckTimer = loopRealityCheckTimer;
        _this.homeURL = homeURL;
        _this.buttons = [];
        _this.passTimeMin = 0;
        _this.passTimeHour = 0;
        _this.passedDelay = 0;
        _this.clientToken = clientToken;
        _this.queryStringData = queryStringData;
        _this.postDataService = new PostDataService();
        _this.realityCheckTimer = new RealityCheckTimer();
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    RealityCheckSwedenService.prototype.init = function (realityCheckObject) {
        console.log("REALITICHECK INIT SWEDEN => ", realityCheckObject);
        this.setRealityCheckObjectByData(realityCheckObject);
    };
    RealityCheckSwedenService.prototype.start = function () {
        if (!this.htmlPopup) {
            return;
        }
        this.htmlPopup.openPopup();
        this.htmlPopup.onClickButton.add(this.onButtonClickCallback, this);
    };
    RealityCheckSwedenService.prototype.end = function () {
        CMA.isRealityCheckFinished = true;
        this.htmlPopup.closePopup();
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    RealityCheckSwedenService.prototype.onButtonClickCallback = function (button) {
        console.log("BUTTON CALLBACK ACTION", button.Action);
        switch (button.Action) {
            case CMAButtonTypeConsts.Continue: {
                this.end();
                break;
            }
            case CMAButtonTypeConsts.Link: {
                CMA.navigateToURL(button.Link);
                this.end();
                break;
            }
            case CMAButtonTypeConsts.Quit: {
                CMA.navigateToURL(this.homeURL);
                this.end();
                break;
            }
            default:
                break;
        }
        this.onTimerComplete.dispatch();
        this.goToLink(button);
        this.restartRealityCheck();
    };
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    RealityCheckSwedenService.prototype.restartRealityCheck = function () {
        console.log("RESTART TIMER");
        if (!this.loopRealityCheckTimer) {
            return;
        }
        if (this.lastRealityCheckObject) {
            this.lastRealityCheckObject.RealityCheckTimeoutPassed = 0;
        }
        this.setRealityCheckObjectByData(this.lastRealityCheckObject);
    };
    RealityCheckSwedenService.prototype.setRealityCheckObjectByData = function (realityCheckObject) {
        this.lastRealityCheckObject = realityCheckObject;
        CMA.isRealityCheckFinished = false;
        // if (this.timer) {
        // 	clearTimeout(this.timer);
        // }
        var delay = this.lastRealityCheckObject.RealityCheckTimeout - this.lastRealityCheckObject.RealityCheckTimeoutPassed;
        // this.timer = setTimeout(()=>{
        // 	this.start();
        // }, delay);
        var delayInMiliseconds = delay * 60 * 1000;
        this.realityCheckTimer.start(delayInMiliseconds, this.realityCheckTimerCallback, this);
        // this.createTextRealityCheckPopup(delay);
    };
    RealityCheckSwedenService.prototype.realityCheckTimerCallback = function (delay) {
        var _this = this;
        console.log("REALITYCHECK CALLBACK => ", delay);
        var testData = {
            clientToken: this.clientToken
        };
        var testresult = this.postDataService.post(testData, this.queryStringData.regulationurl);
        testresult.then(function (res) {
            var stepHour = 60;
            _this.passedDelay += (delay / 60) / 1000;
            var passTimeMin = _this.passedDelay % stepHour;
            var passTimeHour = _this.passedDelay / stepHour;
            passTimeMin = Math.floor(passTimeMin);
            passTimeHour = Math.floor(passTimeHour);
            var text = res.Message[0].Text;
            text = text.replace("[hours]", passTimeHour.toString()).replace("[minutes]", passTimeMin.toString());
            res.Message[0].Text = text;
            // CMA.showPopup(res.Message[0]);
            var htmlData = {
                title: res.Message[0].Title,
                text: res.Message[0].Text,
                buttons: res.Message[0].Buttons
            };
            _this.htmlPopup = CMA.htmlPopupManager.createPopupByType(htmlData, PopupType.RealityCheckPopup);
            _this.start();
        });
    };
    RealityCheckSwedenService.prototype.goToLink = function (button) {
        if (button.Link) {
            window.location.href = button.Link;
        }
    };
    return RealityCheckSwedenService;
}(AbstractCMAService));
/// <reference path="./../../abstractClasses/AbstractCMAService.ts" />
//# sourceURL=game/UiTimerService.js
var UiTimerService = /** @class */ (function (_super) {
    __extends(UiTimerService, _super);
    // -----------------------------------------
    // STATIC PROPERTIES/METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PUBLIC PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PROTECTED PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function UiTimerService() {
        return _super.call(this) || this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    UiTimerService.prototype.start = function (uiTimerUpdate) {
        var quarryParrams = this.getQueryString();
        var totalSeconds = 0;
        if (quarryParrams.loggedintime) {
            totalSeconds = quarryParrams.loggedintime;
        }
        var hour = 0;
        setInterval(function () {
            var minute = 0;
            ++totalSeconds;
            hour = Math.floor(totalSeconds / 3600);
            minute = Math.floor((totalSeconds - hour * 3600) / 60);
            var result = ("0" + hour).substr(-2) + ":" + ("0" + minute).substr(-2);
            uiTimerUpdate(result);
        }, 1000);
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    UiTimerService.prototype.getQueryString = function () {
        var result = {};
        var queryString = location.search.slice(1);
        var re = /([^&=]+)=([^&]*)/g;
        var m;
        while (m = re.exec(queryString)) {
            result[decodeURIComponent(m[1]).toLowerCase()] = decodeURIComponent(m[2]);
        }
        return result;
    };
    ;
    return UiTimerService;
}(AbstractCMAService));
/// <reference path="./../../abstractClasses/AbstractHTMLPopup.ts" />
//# sourceURL=game/RealityCheckUKHTMLPopup.js
/**
 * Created by Ilian Bratanov on 3/26/2018.
 */
var RealityCheckUKHTMLPopup = /** @class */ (function (_super) {
    __extends(RealityCheckUKHTMLPopup, _super);
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function RealityCheckUKHTMLPopup(data) {
        var _this = _super.call(this, data) || this;
        // -----------------------------------------
        // STATIC PROPERTIES/METHODS
        // -----------------------------------------
        // -----------------------------------------
        // PUBLIC PROPERTIES
        /** Additional scale factor for portrait mode - may be overridden (set 0 to disable resize) */
        _this.PORTRAIT_SCALE_FACTOR = 1.75;
        _this.onDropdownButtonClick = new Signal();
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    RealityCheckUKHTMLPopup.prototype.openPopup = function () {
        this.backgroundDiv = this.createDivBackground();
        _super.prototype.openPopup.call(this);
        this.restyleGenericPopupButtons(this.buttonsPopupDiv, this.getAmountButtons());
    };
    RealityCheckUKHTMLPopup.prototype.closePopup = function () {
        _super.prototype.closePopup.call(this);
        if (this.backgroundDiv) {
            this.backgroundDiv.remove();
        }
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    RealityCheckUKHTMLPopup.prototype.createPopupDomElementsByData = function (data) {
        _super.prototype.createPopupDomElementsByData.call(this, data);
        if (data.dropdownButtons) {
            this.createDropdownMenu(data.dropdownButtons);
        }
    };
    RealityCheckUKHTMLPopup.prototype.onAppResize = function () {
        _super.prototype.onAppResize.call(this);
        var isPortrait = this.isPortraitOrientation();
        if (isPortrait) {
            if (this.dropdownSelect) {
                this.dropdownSelect.addClass("dropdown-select-portrain");
            }
        }
        else {
            if (this.dropdownSelect) {
                this.dropdownSelect.removeClass("dropdown-select-portrain");
            }
        }
    };
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    RealityCheckUKHTMLPopup.prototype.createDropdownMenu = function (dropdownButtons) {
        if (this.messagePopupDiv) {
            this.messagePopupDiv.attr("style", "font-size: 1.4vw");
        }
        var that = this;
        this.createDropdownDomElements();
        // defalt select by dropdown
        var optionElement = $("<option/>", {
            class: "dropdown-value",
            selected: "selected",
            value: dropdownButtons[0],
            label: dropdownButtons[0]
        }).appendTo(this.dropdownSelect);
        for (var index = 1; index < dropdownButtons.length; index++) {
            optionElement = $("<option/>", {
                class: "dropdown-value",
                label: dropdownButtons[index],
                value: dropdownButtons[index]
            }).appendTo(this.dropdownSelect);
        }
        var label = $("<label/>", {
            text: "Set time period",
            class: "label-time-period"
        }).appendTo(this.dropdownDiv);
        var selectedValue = this.dropdownSelect.val();
        this.dropdownSelect.change(function () {
            selectedValue = that.dropdownSelect.val();
            that.onDropdownButtonClick.dispatch(selectedValue);
        });
        this.onDropdownButtonClick.dispatch(selectedValue);
    };
    RealityCheckUKHTMLPopup.prototype.createDropdownDomElements = function () {
        this.dropdownDiv = $('<div/>', {
            id: "dropdown"
        }).appendTo(this.messagePopupDiv);
        this.dropdownSelect = $('<select/>', {
            class: "dropdown-select",
            name: "selectTime"
        }).appendTo(this.dropdownDiv);
    };
    return RealityCheckUKHTMLPopup;
}(AbstractHTMLPopup));
/// <reference path="./../../abstractClasses/AbstractCMAService.ts" />
//# sourceURL=game/RealityCheckUKService.jsjs
var RealityCheckUKService = /** @class */ (function (_super) {
    __extends(RealityCheckUKService, _super);
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function RealityCheckUKService(loopRealityCheckTimer, clientToken, playerTokenId, homeURL) {
        var _this = _super.call(this) || this;
        // -----------------------------------------
        // STATIC PROPERTIES/METHODS
        // -----------------------------------------
        // -----------------------------------------
        // PUBLIC PROPERTIES
        // -----------------------------------------
        _this.onTimerComplete = new Signal();
        _this.loopRealityCheckTimer = loopRealityCheckTimer;
        _this.homeURL = homeURL;
        _this.buttons = [];
        _this.passTimeMin = 0;
        _this.passTimeHour = 0;
        _this.passTimeMilliseconds = 0;
        // this.passedDelay = 0;
        _this.eventsNotificationService = new PostDataService(_this.homeURL);
        _this.clientToken = clientToken;
        _this.playerTokenId = playerTokenId;
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    RealityCheckUKService.prototype.init = function (realityCheckObject) {
        this.setRealityCheckObjectByData(realityCheckObject);
    };
    RealityCheckUKService.prototype.start = function () {
        if (!this.htmlPopup) {
            return;
        }
        this.htmlPopup.openPopup();
        this.htmlPopup.onClickButton.add(this.onButtonClickCallback, this);
    };
    RealityCheckUKService.prototype.end = function () {
        CMA.isRealityCheckFinished = true;
        this.htmlPopup.closePopup();
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    RealityCheckUKService.prototype.onButtonClickCallback = function (button) {
        //debugger;
        switch (button.Action) {
            case CMAButtonTypeConsts.Continue: {
                if (this.lastRealityCheckObject.RealityCheck_NotificationContinueUrl) {
                    this.eventsNotificationService.sendNotification(this.lastRealityCheckObject.RealityCheck_NotificationContinueUrl, this.clientToken, this.playerTokenId);
                }
                this.end();
                break;
            }
            case CMAButtonTypeConsts.Cashier: {
                CMA.navigateToURL(button.Link);
                this.end();
                break;
            }
            case CMAButtonTypeConsts.History: {
                CMA.navigateToURL(button.Link);
                this.end();
                break;
            }
            case CMAButtonTypeConsts.Link: {
                CMA.navigateToURL(button.Link);
                this.end();
                break;
            }
            case CMAButtonTypeConsts.Quit: {
                if (this.lastRealityCheckObject.RealityCheck_NotificationQuitUrl) {
                    this.eventsNotificationService.sendNotification(this.lastRealityCheckObject.RealityCheck_NotificationQuitUrl, this.clientToken, this.playerTokenId);
                }
                CMA.navigateToURL(this.homeURL);
                this.end();
                break;
            }
            default:
                break;
        }
        this.onTimerComplete.dispatch();
        this.postRequast(button);
        this.restartRealityCheck();
    };
    RealityCheckUKService.prototype.restartRealityCheck = function () {
        if (!this.loopRealityCheckTimer) {
            return;
        }
        if (this.lastRealityCheckObject) {
            this.lastRealityCheckObject.ShowRealityCheck = false;
            // this.lastRealityCheckObject.RealityCheckTimeoutPassed = 0;
        }
        this.setRealityCheckObjectByData(this.lastRealityCheckObject);
    };
    RealityCheckUKService.prototype.setRealityCheckObjectByData = function (realityCheckObject) {
        var _this = this;
        this.lastRealityCheckObject = realityCheckObject;
        if (this.timer) {
            clearTimeout(this.timer);
        }
        // var delay = this.lastRealityCheckObject.RealityCheckTimeout - this.lastRealityCheckObject.RealityCheckTimeoutPassed;
        var delay = this.lastRealityCheckObject.RealityCheckTimeout - ((this.lastRealityCheckObject.RealityCheckTimeoutPassed + this.passTimeMilliseconds) % this.lastRealityCheckObject.RealityCheckTimeout);
        if (!delay) {
            delay = 0;
        }
        // If in load game response RealityCheckTimeoutPassed % RealityCheckTimeout === 0, the delay is set to one milisecound so the reality check popup is shown at the beginning of the game
        if (this.passTimeMilliseconds === 0 && this.lastRealityCheckObject.RealityCheckTimeoutPassed > 0 &&
            this.lastRealityCheckObject.RealityCheckTimeoutPassed % this.lastRealityCheckObject.RealityCheckTimeout === 0) {
            delay = 1;
        }
        this.timer = setTimeout(function () {
            _this.start();
        }, delay);
        this.createTextRealityCheckPopup(delay);
        CMA.isRealityCheckFinished = false;
    };
    RealityCheckUKService.prototype.createTextRealityCheckPopup = function (passedTime) {
        var _this = this;
        var stepHour = 60;
        this.passTimeMilliseconds += passedTime;
        // this.passedDelay += (passedTime / 60) / 1000;
        var totalPassedTimeMin = ((this.lastRealityCheckObject.RealityCheckTimeoutPassed + this.passTimeMilliseconds) / 1000) / 60;
        this.passTimeMin = totalPassedTimeMin % stepHour;
        this.passTimeHour = totalPassedTimeMin / stepHour;
        this.passTimeMin = Math.floor(this.passTimeMin);
        this.passTimeHour = Math.floor(this.passTimeHour);
        var title = this.lastRealityCheckObject.Message.Title;
        var text = this.lastRealityCheckObject.Message.Text;
        var text2 = this.lastRealityCheckObject.Message.Text2;
        var buttons = this.lastRealityCheckObject.Message.Buttons;
        text = text.replace("{0}", this.passTimeHour.toString()).replace("{1}", this.passTimeMin.toString());
        var htmlData = {
            title: this.lastRealityCheckObject.Message.Title,
            text: text,
            buttons: this.lastRealityCheckObject.Message.Buttons
        };
        if (text2) {
            htmlData.text2 = text2;
        }
        if (this.lastRealityCheckObject.RealityCheckAvailableTimePeriods.length) {
            htmlData.dropdownButtons = this.lastRealityCheckObject.RealityCheckAvailableTimePeriods;
        }
        this.htmlPopup = CMA.htmlPopupManager.createPopupByType(htmlData, PopupType.RealityCheckPopup);
        this.htmlPopup.onDropdownButtonClick.add(function (value) {
            _this.dropdownValue = value;
        }, this);
    };
    RealityCheckUKService.prototype.postRequast = function (button) {
        if (button.Link && button.LinkType) {
            if (this.dropdownValue) {
                button.Link += this.dropdownValue;
            }
            this.eventsNotificationService.sendNotification(button.Link, this.clientToken, this.playerTokenId);
        }
    };
    return RealityCheckUKService;
}(AbstractCMAService));
//# sourceURL=game/ReplayHTMLPopup.js
/**
 * Created by Ilian Bratanov on 5/8/2018.
 */
var ReplayHTMLPopup = /** @class */ (function (_super) {
    __extends(ReplayHTMLPopup, _super);
    // -----------------------------------------
    // STATIC PROPERTIES/METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PUBLIC PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PROTECTED PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE PROPERTIES
    // -----------------------------------------
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function ReplayHTMLPopup(data) {
        var _this = _super.call(this, data) || this;
        // -----------------------------------------
        // CONFIGURATION
        // -----------------------------------------
        /** Additional scale factor for portrait mode - may be overridden (set 0 to disable resize) */
        _this.PORTRAIT_SCALE_FACTOR = 1.75;
        return _this;
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    ReplayHTMLPopup.prototype.openPopup = function () {
        if (!this.backgroundDiv) {
            this.backgroundDiv = this.createDivBackground();
        }
        _super.prototype.openPopup.call(this);
        this.restyleGenericPopupButtons(this.buttonsPopupDiv, this.getAmountButtons());
    };
    ReplayHTMLPopup.prototype.closePopup = function () {
        _super.prototype.closePopup.call(this);
        if (this.backgroundDiv) {
            this.backgroundDiv.remove();
        }
    };
    return ReplayHTMLPopup;
}(AbstractHTMLPopup));
//# sourceURL=game/ReplayMessageService.js
/**
 * Created by Ilian Bratanov on 5/8/2018.
 */
var ReplayMessageService = /** @class */ (function () {
    // -----------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------
    function ReplayMessageService() {
        this.popups = [];
    }
    // -----------------------------------------
    // PUBLIC METHODS
    // -----------------------------------------
    ReplayMessageService.prototype.initReplayMessage = function (replayMessageObjectModelType) {
        if (this.popup && this.popup.isOpenPopup) {
            this.popup.closePopup();
        }
        this.popup = this.createHTMLPopup(replayMessageObjectModelType);
        this.popups.push(this.popup);
        this.popup.openPopup();
        this.popup.onClickButton.add(this.onButtonClickCallback, this);
    };
    ReplayMessageService.prototype.closeAllReplayPopup = function () {
        this.popups.forEach(function (popup) {
            popup.closePopup();
        });
    };
    // -----------------------------------------
    // PROTECTED METHODS
    // -----------------------------------------
    // -----------------------------------------
    // PRIVATE METHODS
    // -----------------------------------------
    ReplayMessageService.prototype.createHTMLPopup = function (replayObject) {
        var htmlData = {
            title: replayObject.Title,
            text: replayObject.Text,
            buttons: replayObject.Buttons
        };
        var htmlPopup = CMA.htmlPopupManager.createPopupByType(htmlData, PopupType.ReplyPopup);
        return htmlPopup;
    };
    ReplayMessageService.prototype.onButtonClickCallback = function (button) {
        if (button.Callback) {
            button.Callback.call(button.Contex);
        }
        this.closeAllReplayPopup();
    };
    return ReplayMessageService;
}());
/**
 *    @desc       A TypeScript conversion of JS Signals by Miller Medeiros
 *               Released under the MIT license
 *                http://millermedeiros.github.com/js-signals/
 *
 *    @version    1.0 - 7th March 2013
 *
 *    @author    Richard Davey, TypeScript conversion
 *    @author        Miller Medeiros, JS Signals
 *    @author        Robert Penner, AS Signals
 *
 *    @url        http://www.photonstorm.com
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Signals can be used to handle events and event dispatching.
 * You can listen for a Signal by binding a callback / function to it.
 * This is done by using either `Signal.add` or `Signal.addOnce`.
 *
 * For example you can listen for a touch or click event from the Input Manager
 * by using its `onDown` Signal:
 *
 * `game.input.onDown.add(function() { ... });`
 *
 * Rather than inline your function, you can pass a reference:
 *
 * `game.input.onDown.add(clicked, this);`
 * `function clicked () { ... }`
 *
 * In this case the second argument (`this`) is the context in which your function should be called.
 *
 * Now every time the InputManager dispatches the `onDown` signal (or event), your function
 * will be called.
 *
 * Very often a Signal will send arguments to your function.
 * This is specific to the Signal itself.
 * If you're unsure then check the documentation, or failing that simply do:
 *
 * `Signal.add(function() { console.log(arguments); })`
 *
 * and it will log all of the arguments your function received from the Signal.
 *
 * Sprites have lots of default signals you can listen to in their Events class, such as:
 *
 * `sprite.events.onKilled`
 *
 * Which is called automatically whenever the Sprite is killed.
 * There are lots of other events, see the Events component for a list.
 *
 * As well as listening to pre-defined Signals you can also create your own:
 *
 * `var mySignal = new Signal();`
 *
 * This creates a new Signal. You can bind a callback to it:
 *
 * `mySignal.add(myCallback, this);`
 *
 * and then finally when ready you can dispatch the Signal:
 *
 * `mySignal.dispatch(your arguments);`
 *
 * And your callback will be invoked. See the dispatch method for more details.
 *
 * @class Signal
 * @name Signal
 * @author Miller Medeiros
 * @author Georgi Semerdjiev - modified to match Phaser.Signal
 * @constructor
 */
/* tslint:disable */
var Signal = /** @class */ (function () {
    function Signal() {
        /**
         * If Signal should keep record of previously dispatched parameters and
         * automatically execute listener during `add()`/`addOnce()` if Signal was
         * already dispatched before.
         * @type boolean
         */
        this.memorize = false;
        /**
         * If Signal is active and should broadcast events.
         * <p><strong>IMPORTANT:</strong> Setting this property during a dispatch will only affect the next dispatch,
         * if you want to stop the propagation of a signal use `halt()` instead.</p>
         * @type boolean
         */
        this.active = true;
        /**
         * @property _bindings
         * @type Array
         * @private
         */
        this._bindings = [];
        /**
         * @property _prevParams
         * @type Any
         * @private
         */
        this._prevParams = null;
        /**
         * @type boolean
         * @private
         */
        this._shouldPropagate = true;
        /**
         * This variable will be set to true if preventDefault() method is called during dispatching.
         * @type {boolean}
         * @private
         */
        this._defaultPrevented = false;
    }
    /**
     * @method validateListener
     * @param {Any} listener
     * @param {Any} fnName
     */
    Signal.prototype.validateListener = function (listener, fnName) {
        if (typeof listener !== 'function') {
            throw new Error('listener is a required param of {fn}() and should be a Function.'.replace('{fn}', fnName));
        }
    };
    /**
     * Check if listener was attached to Signal.
     * @param {Function} listener
     * @param {Object} [context]
     * @return {boolean} if Signal has the specified listener.
     */
    Signal.prototype.has = function (listener, context) {
        if (context === void 0) { context = null; }
        return this._indexOfListener(listener, context) !== -1;
    };
    /**
     * Add a listener to the signal.
     * An listener is a callback with a related context and priority.
     * You can optionally provide extra arguments which will be passed to the callback after any internal parameters.
     * @param {Function} listener Signal handler function.
     * @param {Object} [listenerContext] Context on which listener will be executed (object that should represent the
     *     `this` letiable inside listener function).
     * @param {Number} [priority] The priority level of the event listener. Listeners with higher priority will be
     *     executed before listeners with lower priority. Listeners with same priority level will be executed at the
     *     same order as they were added. (default = 0)
     * @param {...any} [args=(none)] - Additional arguments to pass to the callback (listener) function. They will be
     *     appended after any arguments usually dispatched.
     * @return {SignalBinding} An Object representing the binding between the Signal and listener.
     */
    Signal.prototype.add = function (listener, listenerContext, priority) {
        if (listenerContext === void 0) { listenerContext = null; }
        if (priority === void 0) { priority = 0; }
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        this.validateListener(listener, 'add');
        return this._registerListener(listener, false, listenerContext, priority, args);
    };
    /**
     * Add listener to the signal that should be removed after first execution (will be executed only once).
     * @param {Function} listener Signal handler function.
     * @param {Object} [listenerContext] Context on which listener will be executed (object that should represent the
     *     `this` letiable inside listener function).
     * @param {Number} [priority] The priority level of the event listener. Listeners with higher priority will be
     *     executed before listeners with lower priority. Listeners with same priority level will be executed at the
     *     same order as they were added. (default = 0)
     * @param {...any} [args=(none)] - Additional arguments to pass to the callback (listener) function. They will be
     *     appended after any arguments usually dispatched.
     * @return {SignalBinding} An Object representing the binding between the Signal and listener.
     */
    Signal.prototype.addOnce = function (listener, listenerContext, priority) {
        if (listenerContext === void 0) { listenerContext = null; }
        if (priority === void 0) { priority = 0; }
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        this.validateListener(listener, 'addOnce');
        return this._registerListener(listener, true, listenerContext, priority, args);
    };
    /**
     * Remove a single listener from the dispatch queue.
     * @param {Function} listener Handler function that should be removed.
     * @param {any} [context] Execution context (since you can add the same handler multiple times if executing in a
     *     different context).
     * @return {Function} Listener handler function.
     */
    Signal.prototype.remove = function (listener, context) {
        if (context === void 0) { context = null; }
        this.validateListener(listener, 'remove');
        var i = this._indexOfListener(listener, context);
        if (i !== -1) {
            this._bindings[i]._destroy(); //no reason to a SignalBinding exist if it isn't attached to a signal
            this._bindings.splice(i, 1);
        }
        return listener;
    };
    /**
     * Remove all listeners from the Signal.
     * @param {any} [context=null] - If specified only listeners for the given context will be removed.
     */
    Signal.prototype.removeAll = function (context) {
        if (context === void 0) { context = null; }
        if (context === undefined) {
            context = null;
        }
        if (!this._bindings) {
            return;
        }
        var n = this._bindings.length;
        while (n--) {
            if (context) {
                if (this._bindings[n].context === context) {
                    this._bindings[n]._destroy();
                    this._bindings.splice(n, 1);
                }
            }
            else {
                this._bindings[n]._destroy();
            }
        }
        if (!context) {
            this._bindings.length = 0;
        }
    };
    /**
     * @return {number} Number of listeners attached to the Signal.
     */
    Signal.prototype.getNumListeners = function () {
        return this._bindings ? this._bindings.length : 0;
    };
    /**
     * Stop propagation of the event, blocking the dispatch to next listeners on the queue.
     * <p><strong>IMPORTANT:</strong> should be called only during signal dispatch, calling it before/after dispatch
     * won't affect signal broadcast.</p>
     * @see Signal.prototype.disable
     */
    Signal.prototype.halt = function () {
        this._shouldPropagate = false;
    };
    /**
     * Stop the default behaviour (if possible) causing this event.
     * <p><strong>IMPORTANT:</strong> should be called only during signal dispatch, calling it before/after dispatch
     * won't have any effect.</p>
     */
    Signal.prototype.preventDefault = function () {
        this._defaultPrevented = true;
    };
    /**
     * Dispatch/Broadcast Signal to all listeners added to the queue.
     * @param {...*} [paramsArr] Parameters that should be passed to each handler.
     * @returns {boolean} true if default was not prevented.
     */
    Signal.prototype.dispatch = function () {
        var paramsArr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            paramsArr[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var n, bindings, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.active || !this._bindings) {
                            return [2 /*return*/, true];
                        }
                        n = this._bindings.length;
                        if (this.memorize) {
                            this._prevParams = paramsArr;
                        }
                        if (!n) {
                            //should come after memorize
                            return [2 /*return*/, true];
                        }
                        bindings = this._bindings.slice(0); //clone array in case add/remove items during dispatch
                        this._shouldPropagate = true; //in case `halt` was called before dispatch or during the previous dispatch.
                        this._defaultPrevented = false;
                        _b.label = 1;
                    case 1:
                        n--;
                        _b.label = 2;
                    case 2:
                        _a = bindings[n] && this._shouldPropagate;
                        if (!_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, bindings[n].execute(paramsArr)];
                    case 3:
                        _a = (_b.sent()) !== false;
                        _b.label = 4;
                    case 4:
                        if (_a) return [3 /*break*/, 1];
                        _b.label = 5;
                    case 5: return [2 /*return*/, !this._defaultPrevented];
                }
            });
        });
    };
    /**
     * Forget memorized arguments.
     * @see Signal.memorize
     */
    Signal.prototype.forget = function () {
        this._prevParams = null;
    };
    /**
     * Remove all bindings from signal and destroy any reference to libs objects (destroy Signal object).
     * <p><strong>IMPORTANT:</strong> calling any method on the signal instance after calling dispose will throw
     * errors.</p>
     */
    Signal.prototype.dispose = function () {
        this.removeAll();
        this._bindings.length = 0;
        this._prevParams = null;
    };
    /**
     * @return {string} String representation of the object.
     */
    Signal.prototype.toString = function () {
        return '[Signal active:' + this.active + ' numListeners:' + this.getNumListeners() + ']';
    };
    /**
     * @param {Function} listener - Signal handler function.
     * @param {boolean} isOnce - Should the listener only be called once?
     * @param {Object} [listenerContext] - The context under which the listener is invoked.
     * @param {Number} [priority] - The priority level of the event listener. Listeners with higher priority will be
     *     executed before listeners with lower priority. Listeners with same priority level will be executed at the
     *     same order as they were added. (default = 0).
     * @param {any[]} [args=(none)] - Additional arguments to pass to the callback (listener) function. They will be
     *     appended after any arguments usually dispatched.
     * @return {SignalBinding} An Object representing the binding between the Signal and listener.
     * @private
     */
    Signal.prototype._registerListener = function (listener, isOnce, listenerContext, priority, args) {
        var prevIndex = this._indexOfListener(listener, listenerContext);
        var binding;
        if (prevIndex !== -1) {
            binding = this._bindings[prevIndex];
            if (binding.isOnce() !== isOnce) {
                throw new Error('You cannot add' + (isOnce ? '' : 'Once') + '() then add' + (!isOnce ? '' : 'Once') + '() the same listener without removing the relationship first.');
            }
        }
        else {
            binding = new SignalBinding(this, listener, isOnce, listenerContext, priority, args);
            this._addBinding(binding);
        }
        if (this.memorize && this._prevParams) {
            binding.execute(this._prevParams);
        }
        return binding;
    };
    /**
     * @method _addBinding
     * @param {SignalBinding} binding
     * @private
     */
    Signal.prototype._addBinding = function (binding) {
        if (!this._bindings) {
            this._bindings = [];
        }
        //simplified insertion sort
        var n = this._bindings.length;
        do {
            --n;
        } while (this._bindings[n] && binding.priority <= this._bindings[n].priority);
        this._bindings.splice(n + 1, 0, binding);
    };
    /**
     * @method _indexOfListener
     * @param {Function} listener - Signal handler function.
     * @param {object} context [context=null] - Signal handler function.
     * @return {number} The index of the listener within the private bindings array.
     * @private
     */
    Signal.prototype._indexOfListener = function (listener, context) {
        if (!this._bindings) {
            return -1;
        }
        if (context === undefined) {
            context = null;
        }
        var n = this._bindings.length;
        var cur;
        while (n--) {
            cur = this._bindings[n];
            if (cur.getListener() === listener && cur.context === context) {
                return n;
            }
        }
        return -1;
    };
    /**
     * Signals Version Number
     * @property VERSION
     * @type String
     */
    Signal.VERSION = '1.0.0';
    return Signal;
}());
/*
 *	@desc   	An object that represents a binding between a Signal and a listener function.
 *               Released under the MIT license
 *				http://millermedeiros.github.com/js-signals/
 *
 *	@version	1.0 - 7th March 2013
 *
 *	@author 	Richard Davey, TypeScript conversion
 *	@author		Miller Medeiros, JS Signals
 *	@author		Robert Penner, AS Signals
 *
 *	@url		http://www.kiwijs.org
 *
 */
var SignalBinding = /** @class */ (function () {
    /**
     * Object that represents a binding between a Signal and a listener function.
     * <br />- <strong>This is an internal constructor and shouldn't be called by regular users.</strong>
     * <br />- inspired by Joa Ebert AS3 SignalBinding and Robert Penner's Slot classes.
     * @author Miller Medeiros
     * @constructor
     * @internal
     * @name SignalBinding
     * @param {Signal} signal Reference to Signal object that listener is currently bound to.
     * @param {Function} listener Handler function bound to the signal.
     * @param {boolean} isOnce If binding should be executed just once.
     * @param {Object} [listenerContext] Context on which listener will be executed (object that should represent the
     *     `this` variable inside listener function).
     * @param {Number} [priority] The priority level of the event listener. (default = 0).
     * @param {any[]} [args=(none)] - Additional arguments to pass to the callback (listener) function. They will be
     *     appended after any arguments usually dispatched.
     */
    function SignalBinding(signal, listener, isOnce, listenerContext, priority, args) {
        if (priority === void 0) { priority = 0; }
        /**
         * If binding is active and should be executed.
         * @type boolean
         */
        this.active = true;
        /**
         * The number of times the handler function has been called.
         * @type Number
         */
        this.callCount = 0;
        this._listener = listener;
        this._isOnce = isOnce;
        this.context = listenerContext;
        this._signal = signal;
        this.priority = priority || 0;
        this._args = args;
    }
    /**
     * Call listener passing arbitrary parameters.
     * <p>If binding was added using `Signal.addOnce()` it will be automatically removed from signal dispatch queue,
     * this method is used internally for the signal dispatch.</p>
     * @param {Array} [paramsArr] Array of parameters that should be passed to the listener
     * @return {*} Value returned by the listener.
     */
    SignalBinding.prototype.execute = function (paramsArr) {
        return __awaiter(this, void 0, void 0, function () {
            var handlerReturn, params;
            return __generator(this, function (_a) {
                if (this.active && !!this._listener) {
                    params = this.params ? this.params.concat(paramsArr) : paramsArr;
                    if (this._args) {
                        params = params.concat(this._args);
                    }
                    handlerReturn = this._listener.apply(this.context, params);
                    this.callCount++;
                    if (this._isOnce) {
                        this.detach();
                    }
                }
                return [2 /*return*/, handlerReturn];
            });
        });
    };
    /**
     * Detach binding from signal.
     * - alias to: mySignal.remove(myBinding.getListener());
     * @return {Function|null} Handler function bound to the signal or `null` if binding was previously detached.
     */
    SignalBinding.prototype.detach = function () {
        return this.isBound() ? this._signal.remove(this._listener, this.context) : undefined;
    };
    /**
     * @return {Boolean} `true` if binding is still bound to the signal and have a listener.
     */
    SignalBinding.prototype.isBound = function () {
        return (!!this._signal && !!this._listener);
    };
    /**
     * @return {boolean} If SignalBinding will only be executed once.
     */
    SignalBinding.prototype.isOnce = function () {
        return this._isOnce;
    };
    /**
     * @return {Function} Handler function bound to the signal.
     */
    SignalBinding.prototype.getListener = function () {
        return this._listener;
    };
    /**
     * @return {Signal} Signal that listener is currently bound to.
     */
    SignalBinding.prototype.getSignal = function () {
        return this._signal;
    };
    /**
     * Delete instance properties
     * @private
     */
    SignalBinding.prototype._destroy = function () {
        delete this._signal;
        delete this._listener;
        delete this.context;
    };
    /**
     * @return {string} String representation of the object.
     */
    SignalBinding.prototype.toString = function () {
        return '[SignalBinding isOnce:' + this._isOnce + ', isBound:' + this.isBound() + ', active:' + this.active + ']';
    };
    return SignalBinding;
}());
